import { Injectable } from '@angular/core';
import { SarStateService } from '@app/services/api/sar_state.service';
import { FlashService } from '@app/services/flash.service';
import { Router } from '@angular/router';
import {
    LoadFail,
    LoadSuccess,
    SarActionTypes,
    Load,
    Create,
    CreateSuccess,
    CreateFail,
    Update,
    UpdateFail,
    UpdateSuccess,
    UpdateOne,
    AddOne,
    AddAll
} from '@core/actions/sar_state.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, concatMap } from 'rxjs/operators';
import { SarState } from '@app/models/sar_state';


@Injectable()
export class SarEffects {
    constructor(
        private actions$: Actions,
        private router: Router,
        private fs: FlashService,
        private sarStatesApi: SarStateService
    ) { }


    @Effect()
    load$: Observable<Action> = this.actions$.pipe(
        ofType<Load>(SarActionTypes.Load),
        map(action => action.options),
        switchMap(options => {
            return this.sarStatesApi.get(options).pipe(
                map((sarStates: SarState[]) => new LoadSuccess(sarStates)),
                catchError(error => of(new LoadFail(error)))
            );
        })
    );

    @Effect()
    loadSuccess$: Observable<Action> = this.actions$.pipe(
        ofType<LoadSuccess>(SarActionTypes.LoadSuccess),
        map(action => new AddAll(action.sarStates))
    );

    @Effect()
    create$: Observable<Action> = this.actions$.pipe(
        ofType<Create>(SarActionTypes.Create),
        map(action => action.sarState),
        switchMap(user =>
            this.sarStatesApi.create(user).pipe(
                map((sarState: SarState) => new CreateSuccess(sarState)),
                catchError(error => of(new CreateFail(error)))
            )
        )
    );

    @Effect()
    createSuccess$: Observable<Action> = this.actions$.pipe(
        ofType<CreateSuccess>(SarActionTypes.CreateSuccess),
        map(action => {
            if(action.sarState && action.sarState.status && action.sarState.status === 'error'){
                this.fs.emit({ type: 'danger', message: action.sarState.message, autoClose: false });
                return new CreateFail(action.sarState.status)
            }else{
                this.fs.emit({ type: 'success', message: 'Estado Sar actualizado' });
                return new AddOne(action.sarState);
            }
            
        })
    );

    @Effect()
    update$: Observable<Action> = this.actions$.pipe(
        ofType<Update>(SarActionTypes.Update),
        map(action => [action.id, action.sarState]),
        switchMap(([id, data]) => {
            return this.sarStatesApi.update(id, data).pipe(
                map((sarStates: SarState) => new UpdateSuccess(id, sarStates)),
                catchError(error => of(new UpdateFail(error)))
            );
        })
    );

    @Effect()
    updateSuccess$: Observable<Action> = this.actions$.pipe(
        ofType<UpdateSuccess>(SarActionTypes.UpdateSuccess),
        map(action => {
            if(action.data && action.data.status && action.data.status === 'error'){
                this.fs.emit({ type: 'danger', message: action.data.message, autoClose: false });
                return new UpdateFail(action.data.status)
            }else{
                this.fs.emit({ type: 'success', message: 'Estado Sar actualizado' });
                // this.router.navigate(['/users']);
                return new UpdateOne(action.data);
            }
        })
    );

}